// @flow
import { ProductosActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    producto: {},
    listaProductos: [],
    loading: false,
    error: false,
    syncing: false
};

type ProductosAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { producto?: {} | null, listaProductos?: [] | null, loading?: boolean, +value ?: boolean };

const Productos = (state: State = INIT_STATE, action: ProductosAction): any => {
    // console.log(action);
    switch (action.type) {
        case ProductosActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case ProductosActionTypes.GET_PRODUCTO: {
                    return {
                        ...state,
                        producto: action.payload.data,
                        error: false,
                        loading: false,
                        syncing: false
                    };
                }
                case ProductosActionTypes.LIST_PRODUCTOS: {
                    return {
                        ...state,
                        listaProductos: action.payload.data,
                        error: false,
                        loading: false,
                        syncing: false
                    };
                }
                case ProductosActionTypes.SYNC_PRODUCTOS: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        syncing: false
                    };
                }
                default:
                    return { ...state };
            }

        case ProductosActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case ProductosActionTypes.GET_PRODUCTO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        producto: {},
                        loading: false,
                        syncing: false
                    };
                }
                case ProductosActionTypes.LIST_PRODUCTOS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaProductos: [],
                        loading: false,
                        syncing: false
                    };
                }
                case ProductosActionTypes.SYNC_PRODUCTOS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        syncing: false
                    };
                }
                default:
                    return { ...state };
            }

        case ProductosActionTypes.GET_PRODUCTO:
            return { ...state, error: false, loading: true, syncing: false };
        case ProductosActionTypes.LIST_PRODUCTOS:
            return { ...state, error: false, loading: true, syncing: false };
        case ProductosActionTypes.SYNC_PRODUCTOS:
            return { ...state, error: false, loading: false, syncing: true };
        case ProductosActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                producto: {},
                listaProductos: [],
                syncing: false
            };
        default:
            return { ...state };
    }
};

export default Productos;
